import { render, staticRenderFns } from "./BaseGrid.vue?vue&type=template&id=6b1ef54a&"
import script from "./BaseGrid.vue?vue&type=script&lang=js&"
export * from "./BaseGrid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BaseGrid.vue"
export default component.exports